export default "__VITE_ASSET__C1FUNk9q__"